import React from 'react';
import { Card, Row, Col, Badge, Button } from 'react-bootstrap';
import { FaFileContract, FaCalendarAlt, FaUserTie, FaInfoCircle, FaExternalLinkAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

// Targeta de resum de dades del contracte; usada a ContratoDetail.
const ContractDataCard = ({ contractData }) => {
    const navigate = useNavigate();

    const showContractButton = contractData.state && contractData.id &&
        ['contrato', 'activado', 'ganada'].some(s => contractData.state.toLowerCase().includes(s));

    const handleCardClick = () => {
        if (showContractButton) {
            navigate(`/contratos/contratos/${contractData.id}`);
        }
    };

    return (
        <Card
            className={`h-100 border-0 shadow-sm rounded-4 overflow-hidden ${showContractButton ? 'cursor-pointer hover-elevate' : ''}`}
            onClick={handleCardClick}
            style={{ cursor: showContractButton ? 'pointer' : 'default' }}
        >
            <Card.Header className="bg-white border-bottom-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <FaFileContract className="me-2" />
                    Información del Contrato
                </div>
            </Card.Header>
            <Card.Body>
                <Row className="g-4">
                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaCalendarAlt className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Fecha Creación</label>
                                <p className="detail-card-value font-monospace">{contractData.create_date || <span className="text-muted fst-italic">No especificada</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaCalendarAlt className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Inicio Estimado</label>
                                <p className="detail-card-value font-monospace">{contractData.start_date || <span className="text-muted fst-italic">No especificada</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaInfoCircle className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Tipo</label>
                                <p className="detail-card-value text-uppercase">
                                    {contractData.type === "simple" ? "CONTRATO NUEVO" :
                                        contractData.type === "renovacion" ? "RENOVACIÓN" :
                                            contractData.type || "No especificado"}
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaInfoCircle className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Estado</label>
                                <div>
                                    <Badge bg="primary">{contractData.state}</Badge>
                                </div>
                            </div>
                        </div>
                    </Col>

                    {contractData.extra_dates && contractData.extra_dates.map((dateItem, idx) => (
                        <Col md={6} key={idx}>
                            <div className="d-flex align-items-center">
                                <FaCalendarAlt className="detail-card-icon" />
                                <div>
                                    <label className="detail-card-label">{dateItem.label}</label>
                                    <p className="detail-card-value font-monospace">{dateItem.value || <span className="text-muted fst-italic">No especificada</span>}</p>
                                </div>
                            </div>
                        </Col>
                    ))}

                    {contractData.prescriptor && (
                        <Col md={12}>
                            <div className="d-flex align-items-center">
                                <FaUserTie className="detail-card-icon" />
                                <div>
                                    <label className="detail-card-label">Agente / Prescriptor</label>
                                    <p className="detail-card-value">{contractData.prescriptor}</p>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>
            </Card.Body>
        </Card>
    );
};

export default ContractDataCard;
